import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Organization } from 'src/app/models/organization';
import { MessageService } from 'src/app/services/message.service';
import { OrganizationQuotas, OrganizationService } from 'src/app/services/organization.service';

@Component({
  selector: 'app-organization-subscription',
  templateUrl: './organization-subscription.component.html',
  styleUrls: ['./organization-subscription.component.scss']
})
export class OrganizationSubscriptionComponent {

  @Input() organization?: Organization;
  @Input() quotas: OrganizationQuotas = {
    volume: {
      value: 0,
      exceeded: false
    },
    trademarks: {
      value: 0,
      exceeded: false
    },
    cases: {
      value: 0,
      exceeded: false
    },
    crawlerUrls: {
      value: 0,
      subscribed: 0,
      reserved: 0,
      available: 0,
      exceeded: false
    },
    exceeded: 0
  }

  @Output() change = new EventEmitter<Organization>();

  logo?: File;

  loading: boolean = false;

  constructor(
    private _message: MessageService,
    private organizationService: OrganizationService,
    private toastr: ToastrService
  ) {

  }

  async ngOnInit() {
  }



  onChange(organization: Organization) {
    this.change.emit(organization);
  }

  round(number: number, decimal: number = 0) {
    return number.toFixed(decimal)
  }

  hasQuota(quota: string) {
    if (this.organization && this.organization.subscription && this.organization.subscription.plan) {
      if (quota === "volume") {
        return this.organization.subscription.plan.maxVolume && this.quotas && this.quotas.volume.value
      }
      if (quota === "trademarks") {
        return this.organization.subscription.plan.maxTrademarks && this.quotas && this.quotas.trademarks.value
      }
      if (quota === "cases") {
        return this.organization.subscription.plan.maxCases && this.quotas && this.quotas.cases.value
      }
      if (quota === "crawlerUrls") {
        return this.quotas && this.quotas.crawlerUrls.subscribed > 0 && this.quotas.crawlerUrls.value
      }
    }
    return false;
  }
  quotaPercentage(quota: string) {
    if (this.organization && this.organization.subscription && this.organization.subscription.plan) {
      if (quota === "volume" && this.organization.subscription.plan.maxVolume && this.quotas && this.quotas.volume.value) {
        return (100 * this.quotas.volume.value) / (this.organization.subscription.plan.maxVolume
          +
          (this.organization.subscription.additionalVolume || 0))
      }
      if (quota === "trademarks" && this.organization.subscription.plan.maxTrademarks && this.quotas && this.quotas.trademarks.value) {
        return (100 * this.quotas.trademarks.value) / (this.organization.subscription.plan.maxTrademarks
          +
          (this.organization.subscription.additionalTrademarks || 0))
      }
      if (quota === "cases" && this.organization.subscription.plan.maxCases && this.quotas && this.quotas.cases.value) {
        return (100 * this.quotas.cases.value) / (this.organization.subscription.plan.maxCases
          +
          (this.organization.subscription.additionalCases || 0))
      }
      // the allowance comes resolved from the backend: plan ceiling plus the organisation's extras
      if (quota === "crawlerUrls" && this.quotas && this.quotas.crawlerUrls.subscribed > 0 && this.quotas.crawlerUrls.value) {
        return (100 * this.quotas.crawlerUrls.value) / this.quotas.crawlerUrls.subscribed
      }
    }
    return 0;

  }
}
